<template>
  <div class="field">
    <!-- <TextInput v-model="ObjServiceType.Code" placeholder=" " :requiredIcon="false" clearable name="Code"
            id="Code" label="Code" :rules="{ required: false }" /> -->
    <label>Code</label>
    <CustomAutoComplete
      name="Code"
      id="Code"
      v-model="ObjServiceType.Code"
      :items="options.fromsCodearray"
      @item-select="passdata"
      :required-icon="true"
      :rules="{ required: true, alphanumeric: true }"
    />
  </div>
  <div class="field">
    <TextInput
      v-model="ObjServiceType.patientid"
      placeholder=" "
      :requiredIcon="false"
      clearable
      name="Patient Id"
      id="Patient Id"
      label="Patient Id"
      :rules="{ required: false }"
    />
  </div>
  <div class="field">
    <TextInput
      v-model="ObjServiceType.userid"
      placeholder=" "
      :requiredIcon="false"
      clearable
      name="User Id"
      id="User Id"
      label="User Id"
      :rules="{ required: false }"
    />
  </div>
</template>

<script lang="ts">
import { defineComponent, ref, onMounted, watch } from "vue";
import TextInput from "../../../../components/FormComponents/TextInput.vue";
import CustomAutoComplete from "../../../../components/FormComponents/AutoComplete.vue";

export default defineComponent({
  components: {
    TextInput,
    CustomAutoComplete,
  },
  props: {
    removechiptype: {
      type: Number,
      default: 0,
    },
    itemsList: {
      type: Array,
      default: [],
    },
  },
  setup(props, { emit }) {
    const ObjServiceType = ref({
      Code: ref(),
      patientid: ref(),
      userid: ref(),
    });
    let options: any = ref({
      fromstorearray: [],
    });
    watch(
      () => ObjServiceType.value.Code,
      (newVal) => {
        emit("updatedcode", ObjServiceType.value.Code);
      }
    );

    watch(
      () => ObjServiceType.value.patientid,
      (newVal) => {
        emit("updatedpatientid", ObjServiceType.value.patientid);
      }
    );

    watch(
      () => ObjServiceType.value.userid,
      (newVal) => {
        emit("updateduserid", ObjServiceType.value.userid);
      }
    );

    watch(
      () => props.removechiptype,
      (newVal) => {
        if (newVal == 1) {
          debugger;
          ObjServiceType.value.Code = "";
        } else if (newVal == 2) {
          ObjServiceType.value.patientid = "";
        } else if (newVal == 3) {
          ObjServiceType.value.userid = "";
        } else if (newVal == 4) {
          ObjServiceType.value.Code = "";
          ObjServiceType.value.patientid = "";
          ObjServiceType.value.userid = "";
        }
      }
    );
    function passdata(data) {
      // alert(JSON.stringify(data.value))
      ObjServiceType.value.Code = data.value.DocNo;
    }
    watch(
      () => ObjServiceType.value.Code,
      (newVal) => {
        debugger;
        //    alert('s')
        options.value.fromsCodearray = props.itemsList.map((item: any) => {
          item["label"] = item["DocNo"];
          item["value"] = item["DocNo"];
          return item;
        });
      }
    );
    return {
      ObjServiceType,
      passdata,
      options,
    };
  },
});
</script>

<style lang="scss" scoped></style>
